import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'Mask'})
export class MaskPipe implements PipeTransform{
    transform(value:string,mask:string){
        value = value.toString();
        let maskared:string = '';
        if (value) {
            let k = 0;
            for (let i = 0; i < mask.length; i++) {
                if (mask[i] == '#') {
                    if (value[k])
                        maskared += value[k++];
                }else {
                    maskared += mask[i];
                }
            }
        }
        return maskared;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/mask.pipe.ts